// @ts-ignore
import { PageHeader } from '@ant-design/pro-layout';
import { Badge,Card,Empty, Menu, Space, Table } from 'antd';
import Search from 'antd/es/input/Search';
import React from 'react';
import styled from 'styled-components';

export const CopyButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  p {
    text-transform: uppercase;
    white-space: nowrap;
    margin: 0;
  }
  path {
    fill: rgba(0, 0, 0, 0.25);
  }
`;

export const EmptyCustom = styled(Empty)`
  padding: 128px 0;
  h5 {
    margin: 0;
  }
  p {
    margin: 0;
  }
  svg {
    width: 64px;
  }
  .ant-empty-image {
    height: auto;
    margin: 0 0 24px;
  }
`;

export const MenuCustomTable = styled(Menu)`
  padding: 0;
  .ant-dropdown-menu-item,
  .ant-menu-item {
    padding: 9px 13px !important;
    margin: 0 !important;
    height: auto;
    line-height: normal;
  }
  .ant-dropdown-menu-item span {
    font-size: 14px;
  }
  @media screen and (max-width: 575px) {
    .ant-menu-item {
      padding: 14px 24px !important;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      line-height: 24px;
      .anticon {
        font-size: 16px;
        + span {
          margin-left: 16px;
        }
      }
    }
  }
`;

export const PageHeaderCustom = styled(PageHeader)`
  font-family: 'Barlow';
  padding: 16px 0;

  &.with-back {
    span.title {
      margin-left: 10px;
    }
  }

  .ant-input-search {
    .ant-input-affix-wrapper {
      height: 32px;
    }
  }
  .align-right {
    text-align: right;
  }
  .ant-page-header-heading-sub-title {
    color: #0a0e25;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -0.03em;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 575px) {
    padding-top: 0;
    .ant-page-header-heading-left {
      width: 100%;
      margin: 0 0 16px;
    }
    .ant-page-header-heading-extra {
    }

    &.nowrap-mobile .ant-page-header-heading {
      flex-wrap: nowrap;
    }
  }
`;

export const ResultsCounter = styled.span`
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #373944;

  span {
    margin: 0 8px 0 5px;
  }
`;

export const SelectedCounter = styled.span`
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  padding: 0 12px;
  margin: 0 12px;
  border-right: 1px solid #f0f0f0;
  border-left: 1px solid #f0f0f0;
  &.mobile-style {
    border: none;
    padding: 0;
    margin: 0;
    margin-left: 35px;
    line-height: 28px;
  }
`;

export const ToggleContentVehicle = styled.div`
  display: none;
  grid-template-columns: repeat(2, 50%);
  padding: 9px;
  font-size: 14px;
  line-height: 14px;
  border-radius: 8px;
  color: rgba(0,0,0,0.45);
  background: #F9F9F9;
  span:nth-child(2) {
    text-align: right;
    color: #000000;
  }
  @media screen and (max-width: 575px) {
    border-radius: 0;
    padding: 9px 16px;

    &.nopadding {
      padding: 9px 0;
    }
  }
  
  &.show {
    display: grid;
  }
`;

export const HorizontalFiltersContainer = styled.div`
  display: flex;
  margin: 0 0 24px;
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px;
  }
  .ant-input-number-lg input,
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)
    .ant-select-selection-search-input {
    height: 38px;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector::after,
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-item,
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-placeholder {
    line-height: 38px;
  }
  @media screen and (max-width: 575px) {
    flex-direction: column;
  }
`;

export const SearchContainer = styled.div`
  padding-right: 8px;
  border-right: 1px solid #f0f0f0;
  width: 25%;
  display: flex;

  button {
    margin-left: 5px;
  }
  @media screen and (max-width: 575px) {
    padding: 0 0 8px;
    border: none;
    width: 100%;
  }
`;

export const ScreenContainer = styled.div`
  .flex-center-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .text-p {
    line-height: 32px;
    margin: 0;
    font-size: 14px;
  }
  .text-span {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    font-weight: 400;
    padding-right: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 32px;
  }
  .ant-table-wrapper {
    margin-top: 16px;
  }
  .ant-table-expanded-row {
    td {
      padding: 0;
      border-top: 1px solid white;
      top: -1px;
      background: #ffffff;
    }
  }
  .ant-table-tbody {
    > tr {
      > td {
        padding: 4px 16px;
        @media screen and (max-width: 575px) {
          padding: 8px 12px;
        }
      }
      @media screen and (max-width: 575px) {
        &.ant-table-expanded-row {
          > td {
            padding: 0;
          }
        }
      }
    }
  }
  .image-table {
    object-fit: cover;
    min-width: 85px;
    max-width: 85px;
    max-height: 48px;
    border-radius: 2px;
  }
  .hide-text-action-button {
    button:first-child {
      display: none;
    }
  }
  .ant-row {
    &.row-fix {
      margin: 0;
      position: relative;
      z-index: 1;
    }
  }
  .ant-table-row-selected {
    & + tr.ant-table-expanded-row {
      > td {
        background: #f0fff8;
        border-color: #f0fff8;
      }
      ${ToggleContentVehicle} {
        background: rgba(0, 0, 0, 0.03);
        &:nth-child(2n) {
          background: transparent;
        }
      }
    }
  }
  .ant-pagination-item,
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: transparent;
    border: none;
  }
  .ant-pagination-item-active {
    a {
      color: #0a3d34;
      background-color: #b8ffe2;
      border-radius: 2px;
    }
  }

  .dropdowns-container {
    .ant-btn {
      margin-left: 10px;
    }
    &.dropdowns-mobile {
      display: none
    }
  }

  @media screen and (max-width: 575px) {
    .ant-table-wrapper {
      margin-top: 16px;
    }
    .image-table {
      min-width: 56px;
      max-width: 56px;
      max-height: 56px;
    }
    .ant-table-wrapper .ant-table-thead {
      th:first-child {
        background: none;
        border: none;
        margin-top: -62px;
        position: absolute !important;
        padding-inline: 8px;
        z-index: 2;
        > .ant-table-selection {
          top: 0;
        }
      }
      th:nth-child(2) {
        display: none;
      }
    }
    .ant-table-pagination.ant-pagination {
      position: relative;
      margin: 0;
      padding: 16px 0 0;
      > li {
        display: none;
        &.ant-pagination-prev,
        &.ant-pagination-next {
          display: inline-block;
        }
        &.ant-pagination-options {
          display: inline-block;
        }
      }
    }
    .bulk-actions-mobile,
    .add-action-mobile {
      position: fixed;
      margin: 0;
      top: 17px;
      z-index: 8;
      right: 60px;
      color: #000000;
    }
    .add-action-mobile {
      right: 16px;
    }

    .dropdowns-container {
      &.dropdowns-desktop {
        display: none;
      }
      &.dropdowns-mobile {
        display: block;
      }
    }
  }

  &.with-tabs {
    padding-top: 20px;

    .ant-tabs-nav-wrap {
      border-bottom: 1px solid var(--neutral-5);
    }

    .ant-tabs-tab, .ant-tabs-tab-active, .ant-tabs-tab+.ant-tabs-tab {
      margin-right: 20px;
    }
  }
`;

export const InfoCardCustom = styled.div``;

export const HeaderCardCustom = styled.div`
  display: flex;
  @media screen and (max-width: 575px) {
    .ant-image {
      width: 56px;
    }
  }
`;

export const ToggleHeaderVehicle = styled.div`
  display: none;
  padding: 0 12px;
  h4,
  p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
    line-height: 22px;
    margin: 0;
  }
  &.show {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding-right: 4px;
  }
`;

export const ListPropsVehicle = styled.section`
  padding: 0 8px 16px;

  ${ToggleContentVehicle} {
    :nth-child(2n) {
      background: transparent;
    }
  }
  @media screen and (max-width: 991px) {
    padding: 0 5px;
  }

  &.form {
    background-color: transparent;

    ${ToggleContentVehicle} {
      background-color: var(--neutral-4);
    }
    ${ToggleContentVehicle} {
      :nth-child(2n) {
        background: none;
      }
    }
  }
`;

export const TableSkeleton = styled.section`
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: hidden;
  padding: 16px;
  background: #ffffff;
  margin-top: 24px;
`;

export const TooltipWrapper = styled.div`
  span {
    width: 100%;
    font-size: 16px !important;
  }
`;

export const HeaderModalCustom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .anticon-close {
    color: rgba(0, 0, 0, 0.25);
  }
  h3 {
    margin: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    .anticon {
      margin-right: 12px;
    }
    & + h3 {
      color: rgba(0, 0, 0, 0.45);
    }
  }
`;

export const ModalButtonsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

export const AvatarCustom = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
`;

export const CreatingBadge = (props: any) => {
  return (
    <Badge
      count={props.count}
      style={{ margin: '0 4px 0 0', backgroundColor: props.active ? '#12DFA9' : '#D9D9D9' }}
    />
  );
};

export const EditBlockHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;

  h4 {
    margin-left: 10px;
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled(EditBlockHeader)`
  max-width: 520px;
  margin-bottom: 0;
  justify-content: space-between;

  div {
    display: flex;
  }

  .ant-skeleton {
    margin-top: -6px;
    float: left;
  }
`;

export const LargeSearch = styled(Search)`
  width: 250px;
  margin-bottom: 25px;

  .ant-input-wrapper.ant-input-group {
    display: flex;
    flex-direction: row-reverse;
  }
  
  .ant-input-group .ant-input-group-addon {
    width: 0;
  }

  .ant-input-group input, .ant-input-group >.ant-input:first-child, .ant-input-group .ant-input-group-addon:first-child {
    height: 32px;
    padding-left: 35px;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    border-end-end-radius: 4px;
    border-start-end-radius: 4px;
    font-size: 14px;

    &:hover {
      border-color: var(--primary-8);
    }

    &:focus {
      border-color: var(--primary-8);
      box-shadow: rgb(0, 0, 0, 0.5) 0px 0px 2px;
    }
  }

  .ant-input-group-addon {
    position: relative;
    z-index: 2;

    button {
      background: transparent;
      border: none;
      padding-left: 5px;
      margin-top: 1px;
      margin-left: 3px;
      height: 30px;

      &:hover {
        color: var(--primary-8) !important;
        background-color: transparent !important;
      }
    }
  }
`;

export const FilterBoxesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;

  @media screen and (max-width: 575px) {
    flex-direction: column;
    .filter-box {
      width: 100% !important;
      margin-bottom: 5px;

      .ant-card-body {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        ::before, ::after {
          display: none
        }

        h3 {
          margin-top: 0
        }
      }
    }
  }

`;

export const FilterBox = styled(Card)`
  display: flex;
  cursor: pointer;

  &.no-filter {
    cursor: initial;
    pointer-events: none;
  }

  &.active {
    border: 1px solid var(--primary-4)
  }


  .ant-card-body {
    padding: 10px;
  }

  span[role=img] {
    padding: 2px;
    margin-right: 5px;
    font-size: 14px;
  }

  span {
    font-size: 12px;
  }

  h3 {
    font-size: 20px;
    margin-bottom: 0;
    margin-top: 10px;
  }
`;

export const CustomSpace = styled(Space)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CleanTable = styled(Table)`
  .ant-table, table,.ant-table-thead th.ant-table-cell {
    background: transparent !important;
    background-color: transparent !important;
  }
  .ant-table-thead {
    background: var(--neutral-4) !important;
    background-color: var(--neutral-4) !important;
    border-radius: 4px;
    margin-bottom: 8px;

    th.ant-table-cell {
      padding-left: 0;
      padding-bottom: 5px;
      font-weight: 300;
      text-transform: uppercase;
      font-size: 14px;
    }
  }
  .ant-table-thead > tr > th {
    padding-inline: 0px !important;
    padding-top: 5px;
    padding-bottom: 0px;
    padding-left: 0 !important;
  }
  .ant-table-thead > tr > th:first-child, .ant-table-tbody >tr >td:first-child  {
    padding-inline-start: 8px !important;
  }
  .ant-table-thead > tr > th:last-child, .ant-table-tbody >tr >td:last-child  {
    padding-inline-end: 8px !important;
  }

  .ant-table-tbody:before {
    content:"@";
    display:block;
    line-height:8px;
    text-indent:-99999px;
  }
  .ant-table-tbody >tr >td {
    border-bottom: 2px solid var(--neutral-4) !important;
    padding: 5px 0px 5px !important;
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
